module.exports = "/_next/static/chunks/fonts/HindMadurai-Normal-d8288be0ded9dc75ab2f6a4030acb76d.woff2";